var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCricle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8917 15.8916C19.15 12.6333 19.15 7.35828 15.8917 4.10828",
    stroke: "#2B91FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10833 4.10828C0.849998 7.36661 0.849998 12.6416 4.10833 15.8916",
    stroke: "#2B91FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25001 17.8417C8.14167 18.15 9.06666 18.3 10 18.3C10.9333 18.2917 11.8583 18.15 12.75 17.8417",
    stroke: "#2B91FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25001 2.15833C8.14167 1.84999 9.06666 1.69995 10 1.69995C10.9333 1.69995 11.8583 1.84999 12.75 2.15833",
    stroke: "#2B91FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28333 10V8.60838C7.28333 6.87505 8.50834 6.1667 10.0083 7.03337L11.2167 7.73339L12.425 8.43336C13.925 9.30003 13.925 10.7167 12.425 11.5834L11.2167 12.2834L10.0083 12.9834C8.50834 13.85 7.28333 13.1417 7.28333 11.4084V10Z",
    fill: "#007BFF",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCricle);
export default __webpack_public_path__ + "static/media/play-cricle.8f9abd730d62f1832f70c82291bab892.svg";
export { ForwardRef as ReactComponent };